import Box from "@mui/material/Box"
import {
  AccountBalanceOutlined,
  AnalyticsOutlined,
  BusinessCenterOutlined,
  CategorySearchOutlined,
  ContentCopyOutlined,
  ContractOutlined,
  DashboardOutlined,
  DescriptionOutlined,
  HistoryOutlined,
  InventoryOutlined,
  ManageAccountsOutlined,
  ReceiptOutlined,
  SellOutlined,
  ShoppingCartOutlined,
  SourceEnvironmentOutlined,
  TuneOutlined,
  WarehouseOutlined,
} from "@mui-symbols-material/w300"

import { FINANCIAL_REPORTING_PERMISSIONS, PermissionActionType } from "@/constants/permissions"
import type { IconMapping, LabelMapping, PermissionMapping } from "@/types/routes"

export const labelMapping: LabelMapping = {
  "/app/dashboard": "Dashboard",
  "/app/orders": "Orders",
  "/app/sales": "Sales",
  "/app/procurement": "Procurement",
  "/app/procurement/vendors": "Vendors",
  "/app/procurement/purchase-orders": "Purchase Orders",
  "/app/procurement/supplier-report": "Supplier Report",
  "/app/inventory": "Inventory Management",
  "/app/companies": "Companies",
  "/app/companies/new/$companyId": "Create New Company",
  "/app/products": "Products",
  "/app/pricing": "Pricing",
  "/app/regulatory": "Regulatory",
  "/app/accounting": "Accounting",
  "/app/financial-reporting": "Financial Reporting",
  "/app/warehouse-receiving": "Warehouse",
  "/app/company": "Our Company",
}

export const permissionMapping: PermissionMapping = {
  "/app/financial-reporting": FINANCIAL_REPORTING_PERMISSIONS,
}

export const adminLabelMapping: LabelMapping = {
  "/app/admin/manage-products": "Manage Products",
  "/app/admin/warehouses": "Manage Warehouses",
  "/app/admin/accounting": "Accounting Admin",
  "/app/admin/system-admin": "System Admin",
  "/app/admin/change-log": "Change Log",
  "/app/admin": "Admin & Settings",
}

export const adminPermissionMapping: PermissionMapping = {
  "/app/admin/manage-products": [
    PermissionActionType.PRODUCT_MAINTENANCE, // Categories, Classes
    PermissionActionType.INSTRUCTION_MAINTENANCE, // Instructions
    PermissionActionType.EQUIVALENT_MAINTENANCE, // Equivalents, Competitor Products
    PermissionActionType.TEST_TEMPLATE_VIEW, // Test Templates
    PermissionActionType.VENDOR_VIEW, // Competitor Products (view-only)
    PermissionActionType.VENDOR_MAINTENANCE, // Competitor Products (view-only)
  ],
  "/app/admin/accounting": [
    PermissionActionType.ACCOUNTING_VIEW,
    PermissionActionType.ACCOUNTING_MAINTENANCE,
    PermissionActionType.ACCOUNTING_MANAGER,
  ],
  "/app/admin/warehouses": [PermissionActionType.WAREHOUSES_MAINTENANCE, PermissionActionType.WAREHOUSES_VIEW],
  "/app/admin/system-admin": [PermissionActionType.USER_MAINTENANCE, PermissionActionType.ROLE_MAINTENANCE],
  "/app/admin/change-log": [PermissionActionType.CHANGE_LOG_VIEW],
}

// Define the mapping for icons
export const iconMapping: IconMapping = {
  "/app/dashboard": <DashboardOutlined width={20} height={20} />,
  "/app/orders": <ContentCopyOutlined width={20} height={20} />,
  "/app/accounting": <AccountBalanceOutlined width={20} height={20} />,
  "/app/financial-reporting": <AnalyticsOutlined width={20} height={20} />,
  "/app/procurement": <ShoppingCartOutlined />,
  "/app/sales": <SellOutlined width={20} height={20} />,
  "/app/inventory": <InventoryOutlined width={20} height={20} />,
  "/app/companies": <SourceEnvironmentOutlined width={20} height={20} />,
  "/app/pricing": <ContractOutlined width={20} height={20} />,
  "/app/regulatory": <DescriptionOutlined width={20} height={20} />,
  "/app/products": <CategorySearchOutlined width={20} height={20} />,
  "/app/warehouse-receiving": <WarehouseOutlined width={20} height={20} />,
  "/app/company": <BusinessCenterOutlined width={20} height={20} />,
  DEFAULT: <Box width={20} height={20} />,
}

export const adminIconMapping: IconMapping = {
  "/app/admin": <ManageAccountsOutlined width={20} height={20} />,
  "/app/admin/manage-products": <TuneOutlined width={20} height={20} />,
  "/app/admin/warehouses": <WarehouseOutlined width={20} height={20} />,
  "/app/admin/accounting": <ReceiptOutlined width={20} height={20} />,
  "/app/admin/system-admin": <ManageAccountsOutlined width={20} height={20} />,
  "/app/admin/change-log": <HistoryOutlined width={20} height={20} />,
  DEFAULT: <Box width={20} height={20} />,
}
